import { baseSchema, Update } from './base'
import { branchSchema } from './branch'
import { generate } from './generate'
import { z } from 'zod'

export const suggestedBranchSchema = baseSchema.extend({
  name: z.string(),
  createdAt: z.string(),
  git: branchSchema.shape.git,
  resolution: z
    .discriminatedUnion('type', [
      z.object({
        type: z.literal('accepted'),
        branchId: z.string(),
      }),
      z.object({
        type: z.literal('dismissed'),
      }),
    ])
    .nullish(),
  resolvedAt: z.string().nullish(),
})

export type SuggestedBranch = z.infer<typeof suggestedBranchSchema>
export type SuggestedBranchUpdate = Update<SuggestedBranch>

export const suggestedBranchBaseOps = generate(
  'suggested-branch',
  suggestedBranchSchema.parse
)
